import type { FC } from 'react';

import { Divider as SparkyDivider } from '@eneco/sparky';

/**
 * CMS-agnostic `Divider` block (Phase E). Field-less — the generated `Divider`
 * type (`@eneco/cms-sanity`) carries no content — so it renders purely from its
 * `_type`. Mirror of the Sitecore-lane component
 * (`libs/sitecore/components/eneco/src/Divider/Divider.tsx`); the production
 * Sitecore path is untouched.
 */
const Divider: FC = () => <SparkyDivider emphasis="low" weight="regular" />;

export default Divider;
